export enum PERFORMANCE_MARKS {
  WRAPPER_INITIAL_LOAD_START_MARK = 'wrapper-app-initial-load-start',
}

export enum PERFORMANCE_MEASURES {
  WRAPPER_INITIAL_LOADING_TIME = 'wrapper-app-initial-load-time',
}
